import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import Seo from "@/components/Seo";
import { toast } from "sonner";

export default function Contact() {
  const [info, setInfo] = useState({});
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  useEffect(() => { api.get("/content/contact").then((r) => setInfo(r.data?.data || {})); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", f); setSent(true); toast.success("Message sent — I'll be in touch soon!"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Seo title="Contact" description="Get in touch with Crochet Kerry for questions or custom orders." />
      <div className="text-center mb-10">
        <p className="text-xs uppercase tracking-luxe text-brand-pink mb-2">Say hello</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl mb-3">Contact</h1>
        <p className="text-muted-foreground max-w-xl mx-auto">{info.intro}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[1fr_300px] gap-10">
        {sent ? (
          <div className="bg-brand-blush/40 rounded-sm p-10 text-center" data-testid="contact-sent"><h3 className="font-serif-display text-2xl mb-2">Thank you!</h3><p className="text-muted-foreground">Your message has been sent. I'll reply as soon as I can.</p></div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input required placeholder="Your name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="border border-brand-border rounded-sm px-3 py-2.5 text-sm bg-white outline-none focus:border-brand-pink" data-testid="contact-name" />
              <input required type="email" placeholder="Your email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="border border-brand-border rounded-sm px-3 py-2.5 text-sm bg-white outline-none focus:border-brand-pink" data-testid="contact-email" />
            </div>
            <input placeholder="Subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} className="w-full border border-brand-border rounded-sm px-3 py-2.5 text-sm bg-white outline-none focus:border-brand-pink" data-testid="contact-subject" />
            <textarea required rows={6} placeholder="Your message (custom order ideas welcome!)" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="w-full border border-brand-border rounded-sm px-3 py-2.5 text-sm bg-white outline-none focus:border-brand-pink" data-testid="contact-message" />
            <button className="bg-brand-ink text-white px-8 py-3 rounded-sm text-sm uppercase tracking-luxe hover:bg-brand-pink hover:text-brand-ink transition-colors" data-testid="contact-submit">Send message</button>
          </form>
        )}
        <div className="space-y-5 bg-brand-blush/40 rounded-sm p-7 h-fit">
          <div className="flex items-start gap-3"><Mail className="w-5 h-5 text-brand-pink mt-0.5" /><div><p className="text-xs uppercase tracking-luxe mb-1">Email</p><a href={`mailto:${info.email}`} className="text-sm underline">{info.email}</a></div></div>
        </div>
      </div>
    </div>
  );
}
